import { FC } from 'react'

import { normalizeKeyInitiativeStatus } from 'partner360/entities/keyInitiatives/model/status'

import { StatusEditMode } from './components/statusEditMode/StatusEditMode'
import { StatusReadonlyMode } from './components/statusReadonlyMode/StatusReadonlyMode'

export interface IStatusProps {
  value?: string
  isReadonly?: boolean
  onClick?: (newStatus: string) => void
}

// TODO: we have the same or similar UI in `KeyInitatives` table. And also helper function.
// TODO: we can extract this as common part of Initatives and reuse it in both places.
export const Status: FC<IStatusProps> = ({ value, isReadonly, onClick }) => {
  if (!value) {
    return null
  }

  if (isReadonly) {
    return <StatusReadonlyMode value={normalizeKeyInitiativeStatus(value)} />
  }

  return <StatusEditMode value={normalizeKeyInitiativeStatus(value)} onClick={onClick} />
}
